import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPackageMonthlyList } from '@/service/dashboard';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: {}
}

export const fetchPackageMonthlyList = createAsyncThunk(
  'packageMonthlyList/fetchPackageMonthlyList',
  async ({query = {}}, {rejectWithValue}) => {
    try {
      const response = await getPackageMonthlyList(query);
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取套餐月度列表失败');
    }
  }
)

const packageMonthlyListSlice = createSlice({
  name: 'packageMonthlyList',
  initialState: defaultState,
  reducers: {
    resetPackageMonthlyListState: (state, action) => {
      state.query = {};
      state.data = {};
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPackageMonthlyList.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.query = action.meta.arg.query;
      })
      .addCase(fetchPackageMonthlyList.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.data = action.payload.data;
        state.query = action.payload.query;
      })
      .addCase(fetchPackageMonthlyList.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.data = {};
      });
  }
})

export const { resetPackageMonthlyListState } = packageMonthlyListSlice.actions;
export default packageMonthlyListSlice.reducer;